/* eslint-disable react/prop-types */
import { useEffect, useState } from "react";
import BookingDetails from "./BookingDetails";
import chair from "../../../assets/images/chair.png";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedBookingTable } from "@/redux/slice/table-slice/booking-table-slice";
import { getSingleTable } from "@/api/table-floor/tableFloor";
import toast from "react-hot-toast";

function DraggAbleComponentView({ data, id, fullDetails }) {
	const dispatch = useDispatch();
	const { table_merges } = useSelector((state) => state.table.table);
	const [isSingleVoucherModalOpen, setIsSingleVoucherModalOpen] = useState(false);
	const closeSingleVoucher = () => {
		setIsSingleVoucherModalOpen(false);
	};

	const matchedMerge = table_merges?.find((merge) =>
		merge.tables?.some((table) => table.id === fullDetails?.id)
	);

	let mergedTableNames = null;

	if (matchedMerge) {
		const matchedTable = matchedMerge.tables.find(
			(table) => table.id === fullDetails?.id
		);

		const otherTables = matchedMerge.tables.filter(
			(table) => table.id !== fullDetails?.id
		);

		mergedTableNames = [
			matchedTable?.name,
			...otherTables.map((table) => table.name),
		].join(" + ");
	}


	function setBookingsAndShowDetails(fullDetails) {
		dispatch(setSelectedBookingTable({
			bookingTablePopup: true,
			bookingDetails: { bookings: [] },
			loading: true
		}));
		getSingleTable(fullDetails?.id, true).then((res) => {
			if (res.status === "success") {
				// setBooking(res?.data?.table?.bookings || []);
				// dispatch(setBookingToDetails(res?.data?.table?.bookings || []));
				dispatch(setSelectedBookingTable({
					bookingTablePopup: true,
					bookingDetails: res?.data?.table ? {
						...res.data.table,
						name: mergedTableNames || res.data.table.name
					} : { bookings: [] },
					loading: false
				}));
				// setItemsDialog(res.data);
				// console.log("Fetched single table data:", res.data);
			} else {
				toast.error(res.message || "Failed to fetch table data");
			}
		}).catch((err) => {
			toast.error(err?.message || "Failed to fetch table data");
		});
	}

	return (
		<>
			<div onClick={() => { setBookingsAndShowDetails(fullDetails) }} id={data?.id} className="cursor-pointer absolute px-5 py-7 flex flex-col items-center justify-center gap-2" style={{
				...data?.style,
				backgroundColor: fullDetails?.bookings?.length > 0 ? "#83c27e" : data?.style?.backgroundColor
			}}>
				<p className="text-sm font-semibold">{mergedTableNames || data?.name}</p>
				<div className="flex gap-2 items-center">
					<img className="h-3 w-2" src={chair} alt="chair-icon" />
					<p className="text-base font-medium">{fullDetails.seat}</p>
				</div>
				<p className="py-1.5 px-3 rounded-full text-xs font-medium bg-color13 w-fit">Booking {`(${fullDetails?.bookings.length})`}</p>
				{fullDetails?.pending_booking_count ?
					<p className="py-1.5 px-3 rounded-full text-xs font-medium bg-color8 w-fit">Pending {`(${fullDetails?.pending_booking_count})`}</p> : null
				}
			</div>
			{/* {
				isSingleVoucherModalOpen && (
					<BookingDetails
						// isOpen={isSingleVoucherModalOpen}
						onClose={closeSingleVoucher}
						itemsDialog={fullDetails}
						tableType="book_table"
					/>
				)
			} */}
		</>
	);
}

export default DraggAbleComponentView;